const { withNormalization } = require('./utils/normalization');
const { setRuleValidator } = require('./utils/validation');

module.exports = withNormalization({
  // Avoid recreating the set on every test invoke
  normalize: rule => ({
    ...rule,
    elements: new Set(rule.elements)
  }),

  test({ params, rule }) {
    if (!params.hasOwnProperty(rule.arrayName)) {
      return false
    }

    const paramsArray = params[rule.arrayName];
    if (!Array.isArray(paramsArray)) {
      return false
    }

    return paramsArray.every(item => rule.elements.has(item));
  },

  validate: setRuleValidator
});
